// @flow
import { ChatActionTypes } from './constants';

const INIT_STATE = {
    usuario: {},
    listaUsuarios: [],
    listaUsuariosInSala: [],
    listaMsg: [],
    mensaje: {},
    mensajeDeleted: {},
    listaSalas: [],
    notifications: {},
    loading: false,
    error: false,
    filters: {},
    missingMsg: [],
    files: [],
    downloadItem: null,
    eventos: [],
    evento: {},
    modifiedEvento: {}
}

type ChatAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { usuario?: {} | null, listaUsuarios?: [] | null, listaSalas?: [] | null, loading?: boolean, +value ?: boolean }

const Chat = (state: State = INIT_STATE, action: ChatAction): any => {
    // console.log('action', action);
    switch (action.type) {
        case ChatActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ChatActionTypes.GET_USUARIO: {
                    return {
                        ...state,
                        usuario: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_SALAS: {
                    return {
                        ...state,
                        listaSalas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_USUARIOS: {
                    return {
                        ...state,
                        listaUsuarios: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_USUARIOS_IN_SALA: {
                    return {
                        ...state,
                        listaUsuariosInSala: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_MSG: {
                    return {
                        ...state,
                        listaMsg: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ChatActionTypes.ADD_MSG: {
                    return {
                        ...state,
                        mensaje: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_NOTIFICATIONS:
                case ChatActionTypes.GET_NOTIFICATIONS: {
                    return {
                        ...state,
                        notifications: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_PINNED: {
                    return {
                        ...state,
                        usuario: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.MISSING_MSG: {
                    return {
                        ...state,
                        missingMsg: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.DELETE_MSG: {
                    return {
                        ...state,
                        mensajeDeleted: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.LIST_FILES: {
                    return {
                        ...state,
                        files: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.DOWNLOAD_FILE: {
                    return {
                        ...state,
                        downloadItem: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.CREATE_FOLDER:
                case ChatActionTypes.DELETE_FILE:
                case ChatActionTypes.UPLOAD_FILE: {
                    return {
                        ...state,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.LIST_EVENTOS_CALENDARIO: {
                    return {
                        ...state,
                        eventos: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.CREATE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        evento: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        modifiedEvento: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                case ChatActionTypes.DELETE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        // evento: action.payload.data,
                        error: false,
                        loading: false
                    };
                }
                default:
                    return { ...state };
            }

        case ChatActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ChatActionTypes.GET_USUARIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        usuario: {},
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_SALAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSalas: [],
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_USUARIOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaUsuarios: [],
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_USUARIOS_IN_SALA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaUsuariosInSala: [],
                        loading: false,
                    };
                }
                case ChatActionTypes.LIST_MSG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaMsg: [],
                        loading: false,
                    };
                }
                case ChatActionTypes.ADD_MSG: {
                    return {
                        ...state,
                        mensaje: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_NOTIFICATIONS:
                case ChatActionTypes.GET_NOTIFICATIONS: {
                    return {
                        ...state,
                        notifications: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_PINNED: {
                    return {
                        ...state,
                        usuario: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.MISSING_MSG: {
                    return {
                        ...state,
                        missingMsg: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.DELETE_MSG: {
                    return {
                        ...state,
                        mensajeDeleted: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.LIST_FILES: {
                    return {
                        ...state,
                        files: [],
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.DOWNLOAD_FILE: {
                    return {
                        ...state,
                        downloadItem: null,
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.CREATE_FOLDER:
                case ChatActionTypes.DELETE_FILE:
                case ChatActionTypes.UPLOAD_FILE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.LIST_EVENTOS_CALENDARIO: {
                    return {
                        ...state,
                        eventos: [],
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.CREATE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        evento: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.UPDATE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        modifiedEvento: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                case ChatActionTypes.DELETE_EVENTO_CALENDARIO: {
                    return {
                        ...state,
                        // evento: {},
                        error: action.payload.error,
                        loading: false
                    };
                }
                default:
                    return { ...state };
            }

        case ChatActionTypes.GET_USUARIO:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_SALAS:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_USUARIOS:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_USUARIOS_IN_SALA:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_MSG:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.ADD_MSG:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.GET_NOTIFICATIONS:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.UPDATE_PINNED:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.UPDATE_NOTIFICATIONS:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.MISSING_MSG:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.DELETE_MSG:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_FILES:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.DOWNLOAD_FILE:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.CREATE_FOLDER:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.DELETE_FILE:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.UPLOAD_FILE:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.LIST_EVENTOS_CALENDARIO:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.CREATE_EVENTO_CALENDARIO:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.UPDATE_EVENTO_CALENDARIO:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.DELETE_EVENTO_CALENDARIO:
            return { ...state, error: false, loading: true };
        case ChatActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                usuario: {},
                listaSalas: [],
                listaUsuarios: [],
                mensaje: {},
                mensajeDeleted: {},
                listaUsuariosInSala: [],
                listaMsg: [],
                notifications: {},
                missingMsg: [],
                files: [],
                downloadItem: null,
                eventos: [],
                evento: {},
                modifiedEvento: {}
            };
        case ChatActionTypes.RESET_MSG:
            return {
                ...state,
                loading: false,
                error: false,
                mensaje: {},
                missingMsg: [],
                mensajeDeleted: {},
            };
        case ChatActionTypes.RESET_EVENTOS:
            return {
                ...state,
                loading: false,
                error: false,
                evento: {},
                modifiedEvento: {}
            };
        case ChatActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Chat;
